import React from 'react';
import '../styles/mendsAi.css';

export type ConversationStatus = 'ai' | 'you' | 'waiting';

export function resolveConversationStatus(aiActive: number, unreadCount?: number, lastMessageFromClient?: boolean): ConversationStatus {
  if (aiActive === 1) return 'ai';
  if (unreadCount && unreadCount > 0) return 'waiting';
  if (lastMessageFromClient) return 'waiting';
  return 'you';
}

const LABELS: Record<ConversationStatus, string> = {
  ai: 'IA atendendo',
  you: 'com você',
  waiting: 'aguardando',
};

const COMPACT: Record<ConversationStatus, string> = {
  ai: 'IA',
  you: 'você',
  waiting: '···',
};

/**
 * Texto do selo. Com IA atendendo e o nome do agente conhecido, diz qual IA é:
 * lista ("IA · Lucas", só o primeiro nome) e cabeçalho ("IA atendendo · Lucas Martins").
 */
export function conversationStatusLabel(
  status: ConversationStatus,
  compact: boolean,
  agentName?: string | null,
): { label: string; title: string } {
  const name = status === 'ai' ? (agentName || '').trim() : '';
  if (!name) return { label: compact ? COMPACT[status] : LABELS[status], title: LABELS[status] };
  const first = name.split(/\s+/)[0].slice(0, 14);
  return {
    label: compact ? `IA · ${first}` : `IA atendendo · ${name}`,
    title: `${name} (IA) está atendendo esta conversa`,
  };
}

export const ConversationStatusBadge: React.FC<{
  status: ConversationStatus;
  compact?: boolean;
  /** Nome do agente de IA que está atendendo (aparece só quando status = 'ai'). */
  agentName?: string | null;
}> = ({ status, compact, agentName }) => {
  const cls =
    status === 'ai' ? 'mai-pill-ai' : status === 'waiting' ? 'mai-pill-wait' : 'mai-pill-you';
  const { label, title } = conversationStatusLabel(status, Boolean(compact), agentName);
  return (
    <span
      className={`mai-pill ${cls} ${compact ? 'citem-ai-status' : ''}`}
      title={title}
    >
      <span className="mai-status-dot" />
      {label}
    </span>
  );
};
